import { Container } from '@cgs/wge';
import { AnticipationConfig } from '../../reels_engine/game_config/game_config';
import { RegularSpinsSoundModel } from '../../reels_engine/reels_sound_model';
import { T_IGameConfigProvider, RESOURCES_COMPONENT_TOKEN } from '../../type_definitions';
import { IGameConfigProvider } from './interfaces/i_game_config_provider';
import { ResourcesComponent } from './resources_component';

export class RegularSpinsSoundModelComponent {
  public readonly regularSpinSoundModel: RegularSpinsSoundModel;

  constructor(container: Container) {
    const resourcesComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    const anticipationConfig =
      container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig.anticipationConfig;
    this.regularSpinSoundModel = new RegularSpinsSoundModel(
      resourcesComponent.sounds,
      anticipationConfig as AnticipationConfig
    );
  }
}
